<template>
  <div
    v-if="post.type || post.title"
    class="MediaTitleComp"
    :class="containerClasses"
  >
    <HotspotDemo
      :type-styles="contentspotStyles"
      :is-contentspot="true"
      :icon-slug="post.type"
    />
    <Heading
      :class="headingClasses"
      :text="post.title"
    />
  </div>
</template>

<script>
import HotspotDemo from '@/components/HotspotDemo.vue'
import Heading from '@/components/text/Heading.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MediaTitle',

  components: {
    HotspotDemo,
    Heading
  },

  props: {
    post: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // Store
    ...mapGetters([ 'myStore' ]),
    // Data
    contentspotStyles() { return this.myStore(['styles', 'contentspot']) },
    mediaTitleStyles() { return this.myStore(['styles', 'media_screens', 'title']) ?? {} },
    // Container
    containerClasses() {
      const { mediaTitleStyles } = this
      return [
        // Position
        'relative',
        // Dimensions
        'min-h-15',
        // Padding
        'px-3 md:px-4 py-2',
        // Display
        'flex-c',
        // Background
        `bg-${mediaTitleStyles.bg_color ?? 'white'}`,
        // Text
        `text-${mediaTitleStyles.text_color ?? 'accent-1'}`,
      ]
    },
    // Title
    headingClasses() {
      const { mediaTitleStyles } = this
      return [
        // Dimensions
        'w-full',
        // Padding
        'pl-3 md:pl-4',
        // Text Align
        `text-${mediaTitleStyles.text_align || 'center'}`,
      ]
    }
  }
}
</script>

